import { createFileRoute, useParams } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LangProvider } from "../contexts/LangContext";
import { ForgotPasswordPage } from "../pages/ForgotPasswordPage";

const langMap: Record<string, string> = {
  oz: "uz-Latn",
  uz: "uz-Cyrl",
  ru: "ru",
  en: "en-US",
};

export const Route = createFileRoute("/$lang/forgot-password")({
  component: ForgotPassword,
});

function ForgotPassword() {
  const { lang } = useParams({ from: "/$lang/forgot-password" });
  const { i18n } = useTranslation();
  useEffect(() => {
    document.documentElement.lang = langMap[lang] || "uz-Latn";
    if (i18n?.changeLanguage) i18n.changeLanguage(lang);
  }, [lang, i18n]);
  return (
    <LangProvider lang={langMap[lang] || "uz-Latn"}>
      <ForgotPasswordPage />
    </LangProvider>
  );
}
